<template>
    <div>
    <v-layout row wrap justify-end align-end>
      <download-excel
        class="v-btn v-btn--floating v-btn--small theme--dark primary"
        :data="enrollmentsFiltered"
        :fields="fields"
        name="reporteMatricula.xls"
      >
        <v-icon color="white">cloud_download</v-icon>
      </download-excel>
    </v-layout>
      <v-card>
        <v-card-title>
          <v-layout row wrap>
            <v-flex xs12 sm12 md2>
              <span>Reportes Matrículas</span>
            </v-flex>
            <v-flex mr-3 xs4>
              <v-select
                :items="enrollments_to_select"
                v-model="filter_enrollment"
                label="Filtrar matrícula"
                item-text="description"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-title>

         <v-data-table
            :headers="headers"
            :items="enrollmentsFiltered"
            :search="search"
            :loading="loading"
          >
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.created_at }}</td>
                <td class="text-xs-center">{{ props.item.siesa_tercero_id }}</td>
                <td class="text-xs-center">{{ props.item.family_id }}</td>
                <td class="text-xs-center">{{ props.item.student_number }}</td>
                <td class="text-xs-center">{{ props.item.full_name }}</td>
                <td class="text-xs-center">{{ props.item.student_grade_enrollment }}</td>
                <td class="text-xs-center">{{ props.item.current_step }}</td>
                <td class="text-xs-center">{{ props.item.payment_type }}</td>
                <td class="text-xs-center">{{ props.item.cicle }}</td>
                <td class="text-xs-center">{{ props.item.platform_payment_total }}</td>
                <td class="text-xs-center">{{ props.item.traceability_code }}</td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
      </v-card>

    </div>
</template>

<script>
import axios from 'axios'
import JsonExcel from 'vue-json-excel'
import { mapGetters } from 'vuex'
export default {
  name: 'school-services-report-view',
  components: {
      'download-excel': JsonExcel,
  },
  data() {
    return {
      headers: [
        { text: 'Fecha y hora creación', align: 'center', value: 'created_at' },
        { text: 'Pagador', align: 'center', value: 'siesa_tercero_id' },
        { text: 'Código familia', align: 'center', value: 'family_id' },
        { text: 'Código estudiante', align: 'center', value: 'student_number' },
        { text: 'Nombre estudiante', align: 'center', value: 'full_name' },
        { text: 'Grado estudiante', align: 'center', value: 'student_grade_enrollment' },
        { text: 'Paso actual', align: 'center', value: 'current_step' },
        { text: 'Tipo pago', align: 'center', value: 'payment_type' },
        { text: 'Ciclo', align: 'center', value: 'cicle' },
        { text: 'Total', align: 'center', value: 'platform_payment_total' },
        { text: 'Cus', align: 'center', value: 'traceability_code' },
      ],
      loadingTable: false,
      dialog: false,
      dialogInfo: false,
      infoTitle: '',
      enrollmentInfoHeaders: [],
      infoItems: [],
      documentsInfo: true,
      path_file: '',
      payment_detail: {},
      enrollments: [],
      loading: false,
      search: '',
      fields: {
          'Fecha y hora creación': 'created_at',
          'Código familia': 'family_id',
          'Código estudiante': 'student_number',
          'Nombre estudiante': 'full_name',
          'Grado estudiante': 'student_grade_enrollment',
          'Paso actual': 'current_step',
          'Tipo pago': 'payment_type',
          'Ciclo': 'cicle',
          'Total': 'platform_payment_total',
          'Cus': 'traceability_code',
      },
      dialogError: false,
      error_siesa: '',
      url_base: window.config.vistaUrl,
      enrollments_to_select: [],
      filter_enrollment: '',
    }
  },
  computed: {
    ...mapGetters({
        enrollment_status: 'currentEnrollment',
    }),
    enrollmentsFiltered() {
      let enrollments_to_filter = this.enrollments
      if (this.filter_enrollment && this.filter_enrollment !== '') {
        enrollments_to_filter = this.enrollments.filter(e => e.enrollment_id == this.filter_enrollment)
      }
      return enrollments_to_filter
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    enrollment_status(newValue, oldValue) {
      this.infoItems = newValue.documents
      if(newValue.enrollment) {
        if(newValue.payment) {
          this.payment_detail = {
            name: newValue.enrollment.description,
            payment_type: newValue.payment.payment_type,
            payment_id: newValue.payment.payment_id,
            traceability_code: newValue.payment.traceability_code,
            updated_at: newValue.payment.updated_at,
            payment_currency: newValue.payment.payment_currency,
            payment_state: newValue.payment.payment_state,
            total: newValue.payment.service_payment_total || newValue.payment.platform_payment_total,
          }
        } else {
          this.payment_detail = {
            name: newValue.enrollment.description,
            payment_type: '',
            payment_id: '',
            traceability_code: '',
            updated_at: '',
            payment_currency: '',
            payment_state: '',
            total: '',
          }
        }
      } else {
        this.payment_detail = {
          name: '',
          payment_type: '',
          payment_id: '',
          traceability_code: '',
          updated_at: '',
          payment_currency: '',
          total: '',
        }
      }
    }
  },
  created() {
    this.getEnrollmentsByFamily()
  },
  methods: {
    async getEnrollmentsByFamily() {
      this.loadingTable = true;
      const { data } = await axios.get('/api/enrollment/reports/yearly')
      this.enrollments = data.report;
      this.enrollments_to_select = data.enrollments
      this.loadingTable = false;
    },
    close() {
      this.dialog = false
    },
    async showEnrollmentDocuments(enrollment_id, student_id) {
        const payload = {
          enrollment_id: enrollment_id,
          student_id: student_id
        }
        await this.$store.dispatch('fetchEnrollmentStatus', payload)

        this.dialogInfo = true;
        this.infoTitle = "Documentos";
        this.enrollmentInfoHeaders = this.documentsHeaders;
        this.documentsInfo = true;
    },
    async showEnrollmentPayments(enrollment_id, student_id) {
      const payload = {
          enrollment_id: enrollment_id,
          student_id: student_id
        }
      await this.$store.dispatch('fetchEnrollmentStatus', payload)

      this.documentsInfo = false;
      this.dialogInfo = true;
      this.infoTitle = "Pagos";
    },

    formatNumber(number) {
      if(typeof number === 'undefined') {
          return 0;
      } else {
          return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    validateIfErrorExist(field) {
      if(field) {
        const result = field.search("SIESA_ERROR")
        if(result === -1){
          return true;
        }else{
          return false
        }
      } else {
        return ''
      }
    },
    showError(error) {
      this.error_siesa = error
      this.dialogError = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/reports_yearly.vue